interface LoadingSpinnerProps {
  viewHeight?: string;
}

const LoadingSpinner = ({
  viewHeight = "min-h-screen",
}: LoadingSpinnerProps) => {
  return (
    <div className={`flex ${viewHeight} items-center justify-center`}>
      <div
        className={
          "h-32 w-32 animate-spin rounded-full border-primary border-b-2"
        }
      />
    </div>
  );
};

export default LoadingSpinner;
